#import "~/graphql/fragments/entryLink.graphql"

fragment flexibleButton on flexibleSections_button_BlockType {
    link: entryLink {
        ...entryLink
    }
    color: colorDropdown
}
